import { FC } from 'react';
import { Helmet } from 'react-helmet';
import { PrintLabelsList } from 'components/EuDdpOrders/PrintLabelsList';
import { EASSpinner } from 'components/EASSpinner';
import { useRequireAuth } from 'routes/useRequireAuth';

export const EuDdpPrintLabelsPage: FC = () => {
	// Opened in a tab of its own from the orders list, so it establishes its own session, and
	// deliberately renders without the Page chrome — nothing but the labels should reach the printer.
	const ifAuth = useRequireAuth();

	if (!ifAuth) return <EASSpinner />;

	return (
		<>
			<Helmet>
				<title>EU DDP Labels List – EAS Control Center</title>
			</Helmet>
			<PrintLabelsList />
		</>
	);
};
